import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (
  typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:8000'
    : 'https://crapule-bxl-production.up.railway.app'
);
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token on mount
    const checkAuth = async () => {
      const token = localStorage.getItem('adminToken');
      if (token) {
        try {
          const response = await axios.post(`${API}/auth/verify?token=${token}`);
          if (response.data.valid) {
            setIsAuthenticated(true);
            setUser({ email: response.data.email, role: response.data.role || 'admin', allowedTabs: response.data.allowedTabs || [] });
          } else {
            localStorage.removeItem('adminToken');
          }
        } catch (error) {
          localStorage.removeItem('adminToken');
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      const { token, email: userEmail } = response.data;

      localStorage.setItem('adminToken', token);
      setIsAuthenticated(true);
      // After login, verify to fetch role and allowed tabs
      try {
        const verify = await axios.post(`${API}/auth/verify?token=${token}`);
        setUser({ email: verify.data.email || userEmail, role: verify.data.role || 'admin', allowedTabs: verify.data.allowedTabs || [] });
      } catch {
        setUser({ email: userEmail, role: 'admin', allowedTabs: [] });
      }

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Erreur de connexion'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
